import { render, staticRenderFns } from "./KgjtWebsiteProductCharacteristics.vue?vue&type=template&id=0704fcba&scoped=true&"
import script from "./KgjtWebsiteProductCharacteristics.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProductCharacteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0704fcba",
  null
  
)

export default component.exports